import "./Diagnose.module.css";
import Header from "@/reusable_sections/Header";
import SchlSselTechnologieCopyCopy from "@/pages/KeyService/sections/SchlSselTechnologieCopyCopy";
import PricingCopyCopyCopy from "@/pages/KeyService/sections/PricingCopyCopyCopy";
import DiagnosticPricing from "./sections/DiagnosticPricing";
import DiagnosticWorkflow from "./sections/DiagnosticWorkflow";
import PricingCopyCopyCopyCopy from "@/pages/KeyService/sections/PricingCopyCopyCopyCopy";
import Footer from "@/reusable_sections/Footer";
export default function DiagnosePage() {
  return <div>
      <Header />
      
      
      <SchlSselTechnologieCopyCopy />
      <PricingCopyCopyCopy />
      <PricingCopyCopyCopyCopy />
      
      
      <Footer />
    
      
      </div>;
}